// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"DateDisplay_dateContainer__RKjB8","dayText":"DateDisplay_dayText__WtpmE","dateText":"DateDisplay_dateText__CZNNZ"};